import VueI18n from "vue-i18n"
import en from '../locales/en'
import es from '../locales/es'
import Vue from "vue"

Vue.use(VueI18n)

export const selectedLocale = 'en';

export default new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    nonExplicitSupportedLngs: true,
    messages: {
        en, es
    }
})